<p-card data-testid="hosting-provider-location-card">
  <h3
    class="text-lg font-semibold mb-4 flex items-center gap-3"
    data-testid="hostingProviderLocation-values-header"
  >
    {{ 'project.steps.hostingProviderLocation' | transloco }}
  </h3>
  <div class="space-y-5">
    <div class="flex flex-col gap-3">
      <label for="hosting-location-select" class="font-medium">
        {{ 'project.steps.selectHostingLocation' | transloco }}
      </label>

      <p-select
        id="hosting-location-select"
        data-testid="hosting-location-select"
        [ngModel]="selectedLocation()"
        (ngModelChange)="onLocationChange($event)"
        [options]="locations()"
        optionValue="isoCode"
        [placeholder]="'project.steps.selectHostingLocationPlaceholder' | transloco"
        class="w-full"
      >
        <ng-template #selectedItem let-country>
          @if (country) {
            <div class="flex items-center gap-2">
              @if (hasFlag(country)) {
                <img
                  [src]="getCountryFlagUrl(country.isoCode)"
                  [alt]="country.isoCode"
                  class="w-5 h-4 object-cover rounded-xs"
                />
              } @else {
                <i class="pi {{ getLocationIconClass(country) }} w-5"></i>
              }
              <span>{{ getLocationDisplayName(country) }}</span>
            </div>
          }
        </ng-template>

        <ng-template #item let-country>
          <div class="flex items-center gap-2">
            @if (hasFlag(country)) {
              <img
                [src]="getCountryFlagUrl(country.isoCode)"
                [alt]="country.isoCode"
                class="w-5 h-4 object-cover rounded-xs"
              />
            } @else {
              <i class="pi {{ getLocationIconClass(country) }} w-5"></i>
            }
            <span>{{ getLocationDisplayName(country) }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>

    @if (shouldShowSaveButton()) {
      <div class="flex justify-end">
        <app-project-step-save-button
          [label]="'project.steps.saveHostingLocation' | transloco"
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </div>
</p-card>
